import { render, staticRenderFns } from "./CuentaFinanciadaCard.vue?vue&type=template&id=65fffc3f&"
import script from "./CuentaFinanciadaCard.vue?vue&type=script&lang=js&"
export * from "./CuentaFinanciadaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports